import React from 'react';

export default () => (
  <svg width="50" height="38" viewBox="0 0 50 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.8667 30.028L46 0L50 3.98601L15.8667 38L0 22.1888L4 18.2028L15.8667 30.028Z" fill="#8B959E" />
  </svg>
);
